import { Moto } from '../types';

export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(price);
};

export const formatPhone = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 3)} ${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
};

export const generateWhatsAppLink = (phone: string, message: string): string => {
  const cleanedPhone = phone.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanedPhone}?text=${encodedMessage}`;
};

export const generateMotoWhatsAppMessage = (moto: Moto): string => {
  return `Olá! Tenho interesse na ${moto.nome} ${moto.modelo} ${moto.ano}. Gostaria de mais informações sobre preço e condições de pagamento.`;
};

export const getMotoStatus = (moto: Moto): { text: string; className: string } => {
  if (moto.estoque <= 0) {
    return { text: 'Esgotado', className: 'bg-red-100 text-red-800' };
  } else if (moto.estoque <= 3) {
    return { text: 'Últimas unidades', className: 'bg-orange-100 text-orange-800' };
  } else if (moto.destaque) {
    return { text: 'Destaque', className: 'bg-blue-100 text-blue-800' };
  }
  return { text: 'Disponível', className: 'bg-green-100 text-green-800' };
};

export const generateId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString('pt-BR');
};

export const calculateAverageRating = (ratings: number[]): number => {
  if (ratings.length === 0) return 0;
  const sum = ratings.reduce((acc, rating) => acc + rating, 0);
  return Math.round((sum / ratings.length) * 10) / 10;
};